// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".user-settings .ui-base-card-body:last-child{padding-bottom:20px}.user-settings .ui-base-card-body .reset-pw-link{font-size:15px;display:block;color:var(--color-action-blue)}.user-settings .ui-base-card-body .reset-pw-link .ui-icon{height:12px;width:12px;fill:var(--color-action-blue)}", ""]);
// Exports
module.exports = exports;
